/**
 * El codigo del idioma activo y el formato de los numeros.
 *
 * Vive aparte de `index.ts` por un motivo muy concreto: **los textos de cada
 * idioma no son todos cadenas.** Unos cuantos son funciones que formatean un
 * numero —`supera: (metros) => \`Supera ${numero(metros)} m\``—, asi que
 * `es.ts` y sus hermanos necesitan `numero()`.
 *
 * Si `numero()` siguiera en `index.ts`, que importa `es.ts` de forma estatica,
 * habria un circulo DE VERDAD y no solo de tipos: `index -> es -> index`. Con
 * el estado aqui el grafo es un arbol —`index` y los cuatro idiomas apuntan a
 * este fichero, y este no apunta a ninguno—, y el troceado de vite vuelve a
 * ser predecible, que es la mitad del sentido de haber repartido los idiomas.
 */

import type { Idioma } from './tipos';

const LOCALES: Record<Idioma, string> = {
  es: 'es-ES',
  en: 'en-US',
  pt: 'pt-BR',
  ru: 'ru-RU',
};

let codigo: Idioma = 'es';

/** Lo llama `fijarIdioma` cuando los textos YA estan cargados, y nadie mas. */
export function fijarCodigo(nuevo: Idioma): void {
  codigo = nuevo;
}

export function codigoActual(): Idioma {
  return codigo;
}

/** Formatea un numero con separador de miles segun el idioma. */
export function numero(n: number): string {
  return n.toLocaleString(LOCALES[codigo]);
}
